import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import gravatar from 'gravatar';
import { connect } from 'react-redux';
import { grey300 } from 'material-ui/styles/colors';
import Dashboard from 'material-ui/svg-icons/action/dashboard';
import PermIdentity from 'material-ui/svg-icons/action/perm-identity';
import ExitToApp from 'material-ui/svg-icons/action/exit-to-app';
import PersonAdd from 'material-ui/svg-icons/social/person-add';
import Extension from 'material-ui/svg-icons/action/extension';
import Settings from 'material-ui/svg-icons/action/settings';
import Home from 'material-ui/svg-icons/action/home';
import AddBox from 'material-ui/svg-icons/content/add-box';
import { logoutUser } from '../../../store/auth/actions';
import { changeLang } from '../../../store/ui/actions';
import { getPoints, fetchPoint } from '../../../store/points/actions';
import { getTrails, fetchTrail } from '../../../store/trails/actions';
import Footer from '../Footer/Footer';
import themeDefault from '../../../styles/theme-default';
import { ListItem } from 'material-ui/List/index';
import { Dialog, FlatButton, Avatar, Paper, Drawer, Subheader } from 'material-ui';
import styles from './LeftDrawer.css';
import Loading from '../Loading/Loading';
import AdminService, { ADMIN } from '../../../services/admin';
import ModuleService from '../../../services/module';
import { SUPER_ADMIN } from '../../../services/admin';
import LangService from '../../../services/lang';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import withTranslation from '../../../hoc/withTranslation';
import {
    ADD_ADMIN_PAGE,
    ADD_APPLICATION_PAGE,
    APPLICATION_MODULE_PAGE,
    APPLICATION_PAGE,
    DASHBOARD, PROFILE_PAGE,
    SETTING_PAGE,
} from '../../../constants/routes';

export class LeftDrawer extends React.Component {

    static propTypes = {
        navDrawerOpen: PropTypes.bool,
        user: PropTypes.object,
    };

    state = {
        logoutModalOpened: false,
        changeLangModalOpened: false,
        langToChange: null,
    };

    componentDidMount() {
        const header = document.getElementById('left-drawer-header-id');
        const footer = document.getElementById('left-drawer-footer-id');
        const content = document.getElementById('left-drawer-content-id');

        if (header && footer && content) {
            const footerHeight = window.getComputedStyle(footer).height;
            const headerHeight = window.getComputedStyle(header).height;

            content.style.maxHeight = 'calc(100vh - ' + headerHeight + ' - ' + footerHeight + ')';
        }
    }

    // Actions

    handleCloseChangeLangModal = () => {
        this.setState({
            changeLangModalOpened: false,
            langToChange: null,
        });
    };

    handleOpenChangeLangModal = (lang) => {
        this.setState({
            langToChange: lang,
            changeLangModalOpened: true,
        });
    };

    handleChangeLang = () => {
        if (this.state.langToChange) {
            const langToChange = this.state.langToChange;

            this.handleCloseChangeLangModal();
            this.props.changeLang(langToChange);

            if (this.props.currentApplication
                && ModuleService.hasModule(this.props.currentApplication,
                    ModuleService.OPEN_EXPLORE,
                )) {
                if (this.props.points[langToChange].length === 0) {
                    this.props.getPoints(this.props.currentApplication, langToChange);
                }
                if (this.props.point) {
                    this.props.fetchPoint(this.props.currentApplication.id,
                        this.props.point.id,
                        langToChange,
                    );
                }
                if (this.props.trails[langToChange].length === 0) {
                    this.props.getTrails(this.props.currentApplication, langToChange);
                }
                if (this.props.trail) {
                    this.props.fetchTrail(this.props.currentApplication.id,
                        this.props.trail.id,
                        langToChange,
                    );
                }
            }
        }
    };

    handleOpenLogoutModal = () => {
        this.setState({
            logoutModalOpened: true,
        });
    };

    handleCloseLogoutModal = () => {
        this.setState({
            logoutModalOpened: false,
        });
    };

    handleLogout = () => {
        this.handleCloseLogoutModal();
        this.props.logoutUser();
    };

    // Render

    renderChangeLangDialog() {
        const actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                primary={false}
                onClick={this.handleCloseChangeLangModal}
            />,
            <FlatButton
                label={this.props.t('drawer.change_lang')}
                primary={true}
                onClick={this.handleChangeLang}
            />,
        ];

        return (
            <Dialog
                title={this.props.t('generic.lang')}
                actions={actions}
                modal={false}
                open={this.state.changeLangModalOpened}
                onRequestClose={this.handleCloseChangeLangModal}
            >
                <div dangerouslySetInnerHTML={{
                    __html: this.props.t('drawer.change_lang_confirmation', {
                        lang: LangService.translatedName(this.state.langToChange),
                    }),
                }} />
            </Dialog>
        );
    }

    renderLogoutDialog() {
        const actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                primary={false}
                onClick={this.handleCloseLogoutModal}
            />,
            <FlatButton
                label={this.props.t('drawer.logout')}
                primary={true}
                onClick={this.handleLogout}
            />,
        ];

        return (
            <Dialog
                title={this.props.t('drawer.logout')}
                actions={actions}
                modal={false}
                open={this.state.logoutModalOpened}
                onRequestClose={this.handleCloseLogoutModal}
            >
                {this.props.t('drawer.logout_confirmation')}
            </Dialog>
        );
    }

    render() {
        let {
            navDrawerOpen,
            authenticated,
            user,
        } = this.props;
        let menuSections = [
            {
                visible: true,
                divider: true,
                header: null,
                items: [
                    {
                        title: this.props.t('generic.dashboard'),
                        icon: <Dashboard />,
                        containerElement: <Link to={DASHBOARD} />,
                    },
                ],
            },
        ];

        if (this.props.currentApplication) {
            let modules = this.props.currentApplication.modules
                .filter((moduleId) => {
                    return ModuleService.getModule(moduleId);
                })
                .map((moduleId) => {
                    let module = ModuleService.getModule(moduleId);
                    if (module.path !== undefined) {
                        let url = APPLICATION_MODULE_PAGE
                            .replace(':appId', this.props.currentApplication.id)
                            .replace(':module', module.path);
                        return {
                            title: ModuleService.translatedName(module),
                            icon: <Extension />,
                            containerElement: <Link to={url} />,
                        };
                    } else {
                        return null;
                    }
                });

            if (modules.length === 0) {
                modules = [
                    {
                        title: this.props.t('drawer.no_module'),
                        icon: <Extension />,
                        containerElement: <Link
                            to={APPLICATION_PAGE.replace(':appId',
                                this.props.currentApplication.id,
                            )} />,
                    },
                ];
            }
            let dropdownItems = LangService.langs.map((lang, index) => {
                return <MenuItem
                    key={lang.key}
                    value={lang.key}
                    primaryText={LangService.translatedName(lang.key)}
                />;
            });
            let items = [
                {
                    component:
                        <DropDownMenu style={styles.langDropdown}
                                      key="dropdown_lang"
                                      value={this.props.currentLang}
                                      onChange={(event, index, value) => {
                                          this.handleOpenChangeLangModal(value);
                                      }}>
                            {dropdownItems}
                        </DropDownMenu>,
                },
                {
                    title: this.props.t('generic.detail'),
                    icon: <Home />,
                    containerElement: <Link
                        to={APPLICATION_PAGE.replace(':appId', this.props.currentApplication.id)} />,
                },
            ];

            if (AdminService.isAuthorized(ADMIN, this.props.user)) {
                items.push({
                    title: this.props.t('generic.settings'),
                    icon: <Settings />,
                    containerElement: <Link
                        to={SETTING_PAGE.replace(':appId', this.props.currentApplication.id)} />,
                });
            }

            items.push(...modules);

            menuSections.push(
                {
                    visible: authenticated,
                    divider: true,
                    header: this.props.currentApplication.name,
                    items: items,
                },
            );
        }

        menuSections.push(
            {
                visible: AdminService.isAuthorized(SUPER_ADMIN, this.props.user),
                divider: true,
                header: this.props.t('generic.super_admin'),
                items: [
                    {
                        title: this.props.t('drawer.new_app'),
                        icon: <AddBox />,
                        containerElement: <Link to={ADD_APPLICATION_PAGE} />,
                    },
                    {
                        title: this.props.t('drawer.new_admin'),
                        icon: <PersonAdd />,
                        containerElement: <Link to={ADD_ADMIN_PAGE} />,
                    },
                ],
            },
            {
                visible: authenticated,
                divider: false,
                header: 'Profile',
                items: [
                    {
                        title: this.props.t('drawer.account'),
                        icon: <PermIdentity />,
                        containerElement: <Link to={PROFILE_PAGE} />,
                    },
                    {
                        title: this.props.t('drawer.logout'),
                        icon: <ExitToApp />,
                        onClick: this.handleOpenLogoutModal,
                    },
                ],
            },
        );

        let sectionsComponent = menuSections.map(function (section, sectionIndex) {
            if (section.visible) {
                let itemsComponent = section.items.map(function (item, itemIndex) {
                    if (item && item.component) {
                        return item.component;
                    } else if (item) {
                        return (
                            <ListItem
                                hoverColor={grey300}
                                key={itemIndex}
                                style={styles.menuItem}
                                primaryText={item.title}
                                leftIcon={item.icon}
                                containerElement={item.containerElement}
                                onClick={item.onClick}
                            />
                        );
                    } else {
                        return null;
                    }
                });

                return (
                    <div key={sectionIndex}>
                        {section.header &&
                            <Subheader style={styles.subheader}>{section.header}</Subheader>}
                        {itemsComponent}
                        {/*{section.divider && <Divider/>}*/}
                    </div>
                );
            } else {
                return null;
            }
        });

        return (
            <Drawer docked={true} open={navDrawerOpen}
                    containerStyle={{
                        height: '100vh',
                        overflowY: 'hidden',
                    }}>
                <div id="left-drawer-id" style={styles.drawer}>
                    {this.renderLogoutDialog()}
                    {this.renderChangeLangDialog()}
                    <Paper id="left-drawer-header-id" style={styles.avatar.div}>
                        {!user && <Loading />}
                        {user && <Avatar src={gravatar.url(user.email)}
                                         size={50}
                                         style={styles.avatar.icon} />}
                        {user && <span
                            style={styles.avatar.span}>{AdminService.roleName(this.props.user)}</span>}
                        {user && <span style={styles.avatar.span}>{user.email}</span>}
                    </Paper>
                    <div id="left-drawer-content-id" style={styles.menuContainer}>
                        {sectionsComponent}
                    </div>

                    <Footer backgroundColor={themeDefault.drawer.color} />
                </div>
            </Drawer>
        );
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.auth.authenticated,
        user: state.auth.content,
        currentApplication: state.apps.currentApplication,
        currentLang: state.ui.currentLang,
        points: state.points.content,
        trails: state.trails.content,
        point: state.points.currentPoint,
        trail: state.trails.currentTrail,
    };
}

export default connect(mapStateToProps, {
    getPoints,
    getTrails,
    logoutUser,
    changeLang,
    fetchPoint,
    fetchTrail,
})(withTranslation(LeftDrawer));



// WEBPACK FOOTER //
// src/components/common/LeftDrawer/LeftDrawer.js